import { Theme } from "./theme.types";
import { PartnerConfig } from "../tenant.types";

const DEFAULT_THEME: Theme = {
  colors: {
    primary: "#0000FF",
    secondary: "#FF00FF",
    background: "#F0F0F0",
    text: "#333333",
  },
  cssVariables: {
    "--main-color": "#dfff02",
    "--continue-button-font": "#212121",
    "--back-button-color": "#212121",
    "--secondary-color": "#d8ef46",
    "--brand-surface": "#f8f8f8",
    "--brand-highlight": "transparent",
    "--brand-highlight-padding": "0",
    "--brand-highlight-radius": "0",
    "--brand-card-bg": "transparent",
    "--brand-card-fg": "inherit",
    "--brand-card-radius": "12px",
  },
};

const BENUP_THEME: Theme = {
  ...DEFAULT_THEME,
  cssVariables: {
    ...DEFAULT_THEME.cssVariables,
    "--brand-surface": "#EBF8E4",
    "--brand-highlight": "#9FE86F",
    "--brand-highlight-padding": "2px 12px",
    "--brand-highlight-radius": "8px",
    "--brand-card-bg": "#22420D",
    "--brand-card-fg": "#C8F7A6",
    "--brand-card-radius": "16px",
  },
};

const themes: Record<PartnerConfig, Theme> = {
  DEFAULT: DEFAULT_THEME,
  BENUP: BENUP_THEME,
};

export { themes };
